import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import type { Observable } from 'rxjs'

import { isUrlInternal } from '@app/core/http/is-url-internal'
import * as environment from '@app/environment'

export function defaultHeadersInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (!isUrlInternal(request.url)) {
    return next(request)
  }

  const headers = request.headers
    .append('Accept', 'application/json')
    .append('Content-Type', 'application/json')
    .append('X-Requested-With', 'XMLHttpRequest')
    .append('Browser-Language', navigator && navigator.language)
    .set('Frontend-Build-Id', environment.buildId)

  return next(request.clone({ headers, withCredentials: true }))
}
